<template>
	<div :class="['nk-label-sa', type, color, direction]" v-html="display"></div>
</template>
<script>
	import textVisualizer, { getType, configTranslations } from '@nikan/text-visualizer'
	import { i18nInstance } from '~/plugins/localization'

	const translator = i18nInstance.global.t
	configTranslations({
		debtor: translator('document.f.debtor'),
		creditor: translator('document.f.creditor')
	})

	export default {
		name: 'nikan-label',
		props: ['modelValue', 'options'],
		computed: {
			settings() {
				return Object.assign({}, this.options)
			},
			type() {
				return getType(this.settings.type, this.settings.format)
			},
			color() {
				// [selectedAccountInfo.balance > 0 ? 'text-green' : 'text-red']
				let color = ''
				if (this.options && this.options.nature) {
					switch (this.options.nature) {
						case 'DebtorRemaining':
							color = this.modelValue > 0 ? 'text-red' : 'text-green'
							break
						case 'CreditorRemaining':
							color = this.modelValue < 0 ? 'text-red' : 'text-green'
							break
						case 'AlwaysDebtor':
							color = this.modelValue > 0 ? 'text-red' : 'text-green'
							break
						case 'AlwaysCreditor':
							color = this.modelValue < 0 ? 'text-red' : 'text-green'
							break
						default:
							break
					}
				}
				return color
			},
			display() {
				let visualized = ''
				if (this.settings.type === 'price' && this.settings.decimals > 0)
					visualized = this.monify(this.modelValue)
				else {
					let modelValue = this.settings.zeroString ? this.modelValue.toString() : this.modelValue
					if (modelValue && typeof (modelValue) === 'string')
						modelValue = modelValue.replace('−', '-').replace('‎', '')
					visualized = textVisualizer(modelValue, this.settings)
				}
				return visualized
			},
			direction() {
				return this.settings.direction || ''
			}
		},
	}
</script>
